export default __webpack_public_path__ + "static/media/comments-count.4236796a.svg";